import React from 'react';
import classes from './map.module.css';
import vk from '../../images/vk.png';
import rutube from '../../images/rutube.png';
import img from './img.png';
import { SITE_GEO_AREA_TEXT } from '../../../config/seo';

const Map = () => {
    return (
        <div className={classes._}>
            <iframe
                src="https://yandex.ru/map-widget/v1/?z=12&ol=biz&oid=117473602162"
                width="100%"
                height="600"
                frameBorder="0"
                title="Салон Л.Е.В. на карте — Смоленский бульвар, метро Смоленская"
            />
            <div className={classes.block}>
                <div className={classes.blockContent}>
                    <div className={classes.text1}>Контакты</div>
                    <div className={classes.block2}>
                        <div className={classes.text2}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20"
                                 fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M8 0C4.07456 0 1.21992 2.65655 0.150936 6.66667C-1.2852 12.0541 8 20 8 20C8 20 17.2852 12.0541 15.8491 6.66667C14.7801 2.65655 11.9254 0 8 0ZM8 10.8333C9.76731 10.8333 11.2 9.34095 11.2 7.5C11.2 5.65905 9.76731 4.16667 8 4.16667C6.23269 4.16667 4.8 5.65905 4.8 7.5C4.8 9.34095 6.23269 10.8333 8 10.8333Z"
                                      fill="#E0ECFB"/>
                            </svg>
                            Москва, Смоленский бульвар, 22/14
                        </div>
                        <p className={classes.textGeo}>{SITE_GEO_AREA_TEXT}</p>
                        <div className={classes.text2}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                                 fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM10.8342 10.8333H15.8333C15.8333 10.8333 16.6667 10.8333 16.6667 10C16.6667 9.16667 15.8333 9.16667 15.8333 9.16667H10.8346L10.8333 4.16667C10.8333 4.16667 10.8346 3.33333 10 3.33333C9.16545 3.33333 9.16667 4.16667 9.16667 4.16667L9.16758 9.16697C9.16775 10.0873 9.91389 10.8333 10.8342 10.8333Z"
                                      fill="#E0ECFB"/>
                            </svg>
                            пн.-вс.: 10:00-21:00
                        </div>
                    </div>
                    <div className={classes.blockIcon}>
                        <img src={vk} alt="vk" className={classes.icon}/>
                        <svg xmlns="http://www.w3.org/2000/svg" className={classes.icon} width="25" height="20"
                             viewBox="0 0 25 20" fill="none">
                            <path
                                d="M9.82903 13.1093L9.42121 18.7414C9.59341 18.7587 9.9976 18.7414 10.2369 18.5337C10.4761 18.3261 12.4028 16.5266 13.3363 15.6528C14.8407 16.7256 18.0778 19.0268 18.9913 19.6497C20.1332 20.4284 20.8945 19.8055 21.1664 18.7933C21.4382 17.781 25.027 2.15659 24.9998 1.09247C24.9727 0.0283459 24.1026 -0.179288 23.2326 0.132163C22.3626 0.443614 2.16207 7.86653 1.2105 8.22989C0.258922 8.59325 0.0686011 8.98256 0.0142255 9.11233C-0.0401502 9.2421 0.0414133 9.65737 0.612358 9.89096C1.06911 10.0778 4.7721 11.1627 6.56649 11.6818C10.1734 9.51895 17.5177 5.11538 18.0398 4.80393C18.6923 4.41461 19.8613 3.66195 20.1604 3.55813C20.4595 3.45431 21.0032 3.58409 20.5682 3.94745C20.2202 4.23813 13.2638 10.1765 9.82903 13.1093Z"
                                fill="white"/>
                        </svg>
                        <img src={rutube} alt="rutube" className={classes.icon}/>
                    </div>
                    <a href="tel:+79151897033" className={classes.tel}>+7 915 189-70-33</a>
                    <img src={img} alt={''} className={classes.img}/>
                </div>
                <div className={classes.line}></div>
            </div>
        </div>
    );
};

export default Map;